export function formatUpdatedAt(updatedAt: Date | string | number, now: Date = new Date()): string {
    if (!updatedAt) return '';

    const updated = new Date(updatedAt);
    let diffMs = now.getTime() - updated.getTime();
    if (!Number.isFinite(diffMs) || diffMs < 0) diffMs = 0; // future/invalid → agora

    const sec = Math.floor(diffMs / 1000);
    if (sec < 5) return 'Atualizações salvas agora';

    const DIVISORS = {
        year: 60 * 60 * 24 * 365,
        month: 60 * 60 * 24 * 30,
        day: 60 * 60 * 24,
        hour: 60 * 60,
        minute: 60,
        second: 1,
    } as const;

    type Unit = keyof typeof DIVISORS;

    // pick the biggest matching unit without a loop
    const unit: Unit =
        (sec >= DIVISORS.year && 'year') ||
        (sec >= DIVISORS.month && 'month') ||
        (sec >= DIVISORS.day && 'day') ||
        (sec >= DIVISORS.hour && 'hour') ||
        (sec >= DIVISORS.minute && 'minute') ||
        'second';

    const value = -Math.floor(sec / DIVISORS[unit]); // negative = past for RTF
    const rtf = new Intl.RelativeTimeFormat('pt-BR', { numeric: 'auto' });

    return `Atualizações salvas ${rtf.format(value, unit)}`;
}
